import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import RecordsGallery from '../components/RecordsGallery';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <RecordsGallery />
    </>
  );
};

export default HomePage;
